import { render } from "./ServiceTreePanelComponent.vue?vue&type=template&id=2c2800cd&scoped=true"
import script from "./ServiceTreePanelComponent.vue?vue&type=script&lang=js"
export * from "./ServiceTreePanelComponent.vue?vue&type=script&lang=js"

import "./ServiceTreePanelComponent.vue?vue&type=style&index=0&id=2c2800cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2800cd"]])

export default __exports__